<div class="container text-center">
    <div class="header">
        <h3>Subscription limit reached</h3>
    </div>
    <div class="content">
        <p>Sorry but you appear to have reached your subscription limit.  If you want to continue with your action you will need to upgrade.</p>
        <p>Don't worry, you can easily continue using our service by subscribing to one of our larger usage plans. We have a range of options to suit your needs and budget.</p>
    </div>
  </div>
  